import template from './extra-hotels.html';

const DIRECTIVE_NAME = ExtraHotels.DIRECTIVE_NAME = 'ktExtraHotels';
export default function ExtraHotels() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: ExtraHotelsController,
        controllerAs: '$ctrl',
        scope: {
            hotelSearchResults: `=${DIRECTIVE_NAME}`,
            onShowMoreClicked: `=${DIRECTIVE_NAME}OnShowMoreClicked`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function ExtraHotelsController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
        getNextRadius,
    });

    function $onInit() {
    }

    function getNextRadius() {
        return vm.hotelSearchResults.ExtendedRadius;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/extra-hotels/extra-hotels-component.js